/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';

/**
 * 
 * @export
 * @interface ContractAdjustmentResponseDto
 */
export interface ContractAdjustmentResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentResponseDto
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    adjustmentType: ContractAdjustmentResponseDtoAdjustmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    brokerReference?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    premiumPaymentWarranty?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    underwritingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    tiv?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    premiumAdjustmentAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    cedingCommissionRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    gstRateOnCedingCommission?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    sourceBrokerageRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    ereRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    withholdingTaxRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    aitRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    taxAndFeeAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    otherDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    gstOnEre?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    gstRateOnSourceBrokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    gstRateOnPremium?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ContractAdjustmentResponseDto
     */
    adjustmentIndex: number;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    contractAdjustmentId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    documentNo: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentResponseDto
     */
    ppwDueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentResponseDto
     */
    inceptionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractAdjustmentResponseDto
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    layerPremium: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAdjustmentResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * Only returns in the adjustment detail API
     * @type {Array<UploadedFileResponseDto>}
     * @memberof ContractAdjustmentResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
}


/**
 * @export
 */
export const ContractAdjustmentResponseDtoAdjustmentTypeEnum = {
    PolicyExtension: 'Policy Extension',
    PremiumAdjustment: 'Premium Adjustment',
    Cancellation: 'Cancellation',
    RateUpdate: 'Rate Update',
    StockAdjustment: 'Stock Adjustment',
    NonFinancialEndorsement: 'Non-Financial Endorsement'
} as const;
export type ContractAdjustmentResponseDtoAdjustmentTypeEnum = typeof ContractAdjustmentResponseDtoAdjustmentTypeEnum[keyof typeof ContractAdjustmentResponseDtoAdjustmentTypeEnum];


/**
 * Check if a given object implements the ContractAdjustmentResponseDto interface.
 */
export function instanceOfContractAdjustmentResponseDto(value: object): value is ContractAdjustmentResponseDto {
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('adjustmentType' in value) || value['adjustmentType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('adjustmentIndex' in value) || value['adjustmentIndex'] === undefined) return false;
    if (!('contractAdjustmentId' in value) || value['contractAdjustmentId'] === undefined) return false;
    if (!('documentNo' in value) || value['documentNo'] === undefined) return false;
    if (!('layerPremium' in value) || value['layerPremium'] === undefined) return false;
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    return true;
}

export function ContractAdjustmentResponseDtoFromJSON(json: any): ContractAdjustmentResponseDto {
    return ContractAdjustmentResponseDtoFromJSONTyped(json, false);
}

export function ContractAdjustmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractAdjustmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionDate': (new Date(json['transactionDate'])),
        'adjustmentType': json['adjustmentType'],
        'brokerReference': json['brokerReference'] == null ? undefined : json['brokerReference'],
        'premiumPaymentWarranty': json['premiumPaymentWarranty'] == null ? undefined : json['premiumPaymentWarranty'],
        'underwritingComments': json['underwritingComments'] == null ? undefined : json['underwritingComments'],
        'tiv': json['tiv'] == null ? undefined : json['tiv'],
        'premiumAdjustmentAmount': json['premiumAdjustmentAmount'] == null ? undefined : json['premiumAdjustmentAmount'],
        'cedingCommissionRate': json['cedingCommissionRate'] == null ? undefined : json['cedingCommissionRate'],
        'gstRateOnCedingCommission': json['gstRateOnCedingCommission'] == null ? undefined : json['gstRateOnCedingCommission'],
        'sourceBrokerageRate': json['sourceBrokerageRate'] == null ? undefined : json['sourceBrokerageRate'],
        'ereRate': json['ereRate'] == null ? undefined : json['ereRate'],
        'withholdingTaxRate': json['withholdingTaxRate'] == null ? undefined : json['withholdingTaxRate'],
        'aitRate': json['aitRate'] == null ? undefined : json['aitRate'],
        'taxAndFeeAmount': json['taxAndFeeAmount'] == null ? undefined : json['taxAndFeeAmount'],
        'otherDeductions': json['otherDeductions'] == null ? undefined : json['otherDeductions'],
        'gstOnEre': json['gstOnEre'] == null ? undefined : json['gstOnEre'],
        'gstRateOnSourceBrokerage': json['gstRateOnSourceBrokerage'] == null ? undefined : json['gstRateOnSourceBrokerage'],
        'gstRateOnPremium': json['gstRateOnPremium'] == null ? undefined : json['gstRateOnPremium'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'createdAt': (new Date(json['createdAt'])),
        'adjustmentIndex': json['adjustmentIndex'],
        'contractAdjustmentId': json['contractAdjustmentId'],
        'documentNo': json['documentNo'],
        'ppwDueDate': json['ppwDueDate'] == null ? undefined : (new Date(json['ppwDueDate'])),
        'inceptionDate': json['inceptionDate'] == null ? undefined : (new Date(json['inceptionDate'])),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'layerPremium': json['layerPremium'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
    };
}

export function ContractAdjustmentResponseDtoToJSON(json: any): ContractAdjustmentResponseDto {
    return ContractAdjustmentResponseDtoToJSONTyped(json, false);
}

export function ContractAdjustmentResponseDtoToJSONTyped(value?: ContractAdjustmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionDate': ((value['transactionDate']).toISOString()),
        'adjustmentType': value['adjustmentType'],
        'brokerReference': value['brokerReference'],
        'premiumPaymentWarranty': value['premiumPaymentWarranty'],
        'underwritingComments': value['underwritingComments'],
        'tiv': value['tiv'],
        'premiumAdjustmentAmount': value['premiumAdjustmentAmount'],
        'cedingCommissionRate': value['cedingCommissionRate'],
        'gstRateOnCedingCommission': value['gstRateOnCedingCommission'],
        'sourceBrokerageRate': value['sourceBrokerageRate'],
        'ereRate': value['ereRate'],
        'withholdingTaxRate': value['withholdingTaxRate'],
        'aitRate': value['aitRate'],
        'taxAndFeeAmount': value['taxAndFeeAmount'],
        'otherDeductions': value['otherDeductions'],
        'gstOnEre': value['gstOnEre'],
        'gstRateOnSourceBrokerage': value['gstRateOnSourceBrokerage'],
        'gstRateOnPremium': value['gstRateOnPremium'],
        'binderShareSigned': value['binderShareSigned'],
        'createdAt': ((value['createdAt']).toISOString()),
        'adjustmentIndex': value['adjustmentIndex'],
        'contractAdjustmentId': value['contractAdjustmentId'],
        'documentNo': value['documentNo'],
        'ppwDueDate': value['ppwDueDate'] == null ? undefined : ((value['ppwDueDate']).toISOString()),
        'inceptionDate': value['inceptionDate'] == null ? undefined : ((value['inceptionDate']).toISOString()),
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'layerPremium': value['layerPremium'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
    };
}

